import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";
import logoLeasing from "../../../../assets/images/drawable-header.png";
import dayjs from "dayjs";

/**
 * @param {Object} params
 * @param {Array}  params.dataList
 * @param {Function} params.convertDateThai
 */
export const generateLawsuitListPDF = ({ dataList = [], convertDateThai }) => {
  if (!dataList || dataList.length === 0) {
    alert("ไม่มีข้อมูลสำหรับสร้าง PDF");
    return;
  }

  const pdf = new jsPDF({ orientation: "p" });

  // ============== HELPER ==============
  const formatDate = (val) => {
    if (!val) return "-";
    return dayjs(val).add(543, "year").format("DD MMM YY");
  };

  const checkboxCol1 = 5; // column index ทะเบียน
  const checkboxCol2 = 6; // column index ธุรการกฎหมาย

  const tableBody = dataList.map((item, idx) => [
    (idx + 1).toString(),
    item.CONTNO || "-",
    `${item.SNAM || ""}${item.NAME1 || ""} ${item.NAME2 || ""}`.trim(),
    formatDate(item.ceoSend),
    item.currentStatusAd === 2 ? formatDate(item.acceptDocAd) : "-",
    "", // ทะเบียน
    "", // ธุรการกฎหมาย
  ]);

  // ============== DRAW PAGE FUNCTION ==============
  const drawPage = (label) => {
    // ── LOGO ──
    pdf.addImage(logoLeasing, "PNG", 145, 3, 45, 22);

    // ── LABEL ต้นฉบับ / สำเนา (มุมขวาบน) ──
    pdf.setFont("THSarabunNew", "bold");
    pdf.setFontSize(12);
    pdf.setTextColor(180, 180, 180);
    pdf.text(label, 185, 10);
    pdf.setTextColor(0, 0, 0);

    // ── HEADER ──
    pdf.setFontSize(18);
    pdf.setFont("THSarabunNew", "bold");
    pdf.text("รายการคดี – รายงานตรวจรับเอกสาร", 14, 15);

    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(13);
    pdf.text(`วันที่พิมพ์ ${convertDateThai()}`, 14, 22);
    pdf.text(`จำนวนรายการ ${dataList.length} รายการ`, 14, 28);

    // ── TABLE ──
    pdf.autoTable({
      head: [
        [
          { content: "#", styles: { halign: "center" } },
          { content: "เลขสัญญา", styles: { halign: "center" } },
          { content: "ชื่อ-นามสกุล", styles: { halign: "center" } },
          { content: "วันที่เฮียแจ้งส่งฟ้อง", styles: { halign: "center" } },
          { content: "เตรียมสำเร็จ", styles: { halign: "center" } },
          { content: "☐ ทะเบียน", styles: { halign: "center" } },
          { content: "☐ ธุรการกฎหมาย", styles: { halign: "center" } },
        ],
      ],
      body: tableBody,
      startY: 33,
      styles: {
        font: "THSarabunNew",
        fontSize: 13,
        cellPadding: { top: 4, bottom: 4, left: 3, right: 3 },
        lineColor: [200, 200, 200],
        lineWidth: 0.3,
      },
      headStyles: {
        fillColor: [22, 119, 255],
        textColor: [255, 255, 255],
        fontSize: 13,
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
      },
      alternateRowStyles: {
        fillColor: [240, 246, 255],
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 15 },
        1: { halign: "center", cellWidth: 25 },
        2: { halign: "left", cellWidth: 40 },
        3: { halign: "center", cellWidth: 32 },
        4: { halign: "center", cellWidth: 32 },
        5: { halign: "center", cellWidth: 20 },
        6: { halign: "center", cellWidth: 25 },
      },
      margin: { top: 10, left: 14, right: 14 },
      didDrawCell: (data) => {
        if (data.section !== "body") return;
        if (
          data.column.index !== checkboxCol1 &&
          data.column.index !== checkboxCol2
        )
          return;

        const { x, y, width, height } = data.cell;
        const boxSize = 5;
        const cx = x + width / 2 - boxSize / 2;
        const cy = y + height / 2 - boxSize / 2;

        pdf.setDrawColor(80, 80, 80);
        pdf.setLineWidth(0.4);
        pdf.rect(cx, cy, boxSize, boxSize);
      },
    });

    // ── FOOTER ──
    const finalY = pdf.lastAutoTable.finalY + 8;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(13);
    pdf.setTextColor(0, 0, 0);

    pdf.text(
      "ลงชื่อผู้จัดเตรียมเอกสาร.............................",
      20,
      finalY + 20,
    );
    pdf.text(
      "ลงชื่อรับเอกสาร...................................",
      120,
      finalY + 20,
    );
    pdf.text(
      "(................................................)",
      20,
      finalY + 28,
    );
    pdf.text(
      "(................................................)",
      120,
      finalY + 28,
    );
    pdf.text(
      "วันที่ ............................................",
      20,
      finalY + 36,
    );
    pdf.text(
      "วันที่ ............................................",
      120,
      finalY + 36,
    );
  };

  // ============== PAGE 1 : ต้นฉบับ ==============
  drawPage("(ต้นฉบับ)");

  // ============== PAGE 2 : สำเนา ==============
  pdf.addPage();
  drawPage("(สำเนา)");

  // ============== เปิด PDF ==============
  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const newWindow = window.open(pdfUrl);

  if (newWindow) {
    newWindow.onload = () => newWindow.print();
  } else {
    alert("กรุณาปิดการบล็อกป๊อปอัปเพื่อใช้งานฟังก์ชันนี้");
  }
};
